import { useEffect, useState } from "react";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import TkWireCamDialog from "../dialogTypes/TkWireCamDialog";
import { useTranslation } from "react-i18next";
import defineConf from "../../config/defineConf";

function TkCreateWireCamButton ( props ) {

    const { t } = useTranslation();

    const { id, refresh, onSuccess, onSelectMst, customizeErrorMsgCallback, ...others } = props;

    const [ open, setOpen ] = useState(false);

    const [schema, setSchema] = useState();

    useEffect(()=> {

        let schema = {

            name: "WireWork",
            type: "BASE TABLE",
            searchAll: false,
            columns: [
    
                {
                    name: "num",
                    type: "int(11)",
                    formOrder: 1,
                    formItemType: "number",
                    required : true,
                },
                {
                    name: "wCutNum",
                    type: "int(11)",
                    formOrder: 2,
                    formItemType: "number",
                    required : true,
                },
                {
                    name: "size",
                    type: "varchar(45)",
                    formOrder: 3,
                    formItemType : "select",
                    selectItems : [
                        {
                            name: "selectItems.size.big",
                            value: defineConf.sizeType.BIG
                        },
                        {
                            name: "selectItems.size.small",
                            value: defineConf.sizeType.SMALL
                        },
                        {
                            name: "selectItems.size.common",
                            value: defineConf.sizeType.COMMON
                        },
                    ],
                },
                /* {
                    name: "workTime",
                    type: "int(11)",
                    formOrder: 3,
                    required : true,
                    formItemType: "autocomplete",
                    codeInfo: {
                        tableName: "TimeToSecond",
                        nameColumn: ["timeName"],
                        valueColumn: "second",
                    },
                }, */
                /* {
                    name: "wSuperDrillLength",
                    type: "float",
                    formOrder: 3,
                    formItemType: "float",
                },
                {
                    name: "wSuperDrillQty",
                    type: "int(11)",
                    formOrder: 4,
                    formItemType: "number",
                }, */
                {
                    name: "workers",
                    formOrder: 10,
                    hideInForm: false,
                    formGroup: 0,
                    formItemType: "multipleAutocomplete",
                    required : true,
                    codeInfo: {
                        tableName: "User",
                        nameColumn: ["fullName"],
                        valueColumn: "username",
                        useEmptyValue: false,
                        sortByName: true,
                    },
                    width : "100%"
                },
    
            ]
        };
        
        setSchema(schema);

    },[])

    const onOpen = () => {

        setOpen ( true );

    };

    const onClose = () => {

        setOpen ( false );

    };

    const onCreateSuccess = ( msg ) => {

        if ( onSuccess ) {

            onSuccess ( msg );

        }

        refresh.refresh ();

    };

    return (

        <>
            <CreateRecordButtonLayout id={id+"create-tkwire"} onClick={onOpen} {...others} />
            <TkWireCamDialog
                id={id+"create-tkwire-cam-Dialog"}
                mode="create"
                formId={id+"create-tkwire-cam-form"}
                title={schema ? t(`dialog.title.${id}.wireCam.create`) : ""}
                schema = {schema}
                onSelectMst = {onSelectMst}
                initialData={undefined}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
            />
        </>

    );
}

export default TkCreateWireCamButton;

